var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoozBoys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 89,
    viewBox: "0 0 220 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4270_198475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7537 49.1232C67.7537 31.5181 53.4819 17.2463 35.8768 17.2463C18.2717 17.2463 4 31.5181 4 49.1232C4 66.7283 18.2717 81 35.8768 81C53.4819 81 67.7537 66.7283 67.7537 49.1232Z",
    fill: "#383566"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27 70.6376C19.2813 70.6376 13 64.6295 13 57.2463H16.3241C16.3241 62.875 21.1155 67.4581 27 67.4581C32.8845 67.4581 37.6759 62.875 37.6759 57.2463H41C41 64.6295 34.7187 70.6376 27 70.6376Z",
    fill: "#9F9ED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8801 17.2463C20.292 17.2463 7.25187 28.5921 4.54089 43.4242C5.00359 43.4503 5.45324 43.4959 5.92245 43.4959C13.8925 43.4959 21.0935 40.1072 26.2092 34.7243C31.3249 40.1072 38.5259 43.4959 46.4959 43.4959C48.2229 43.4959 49.9042 43.3135 51.5399 43.0137V43.0267C56.1082 43.0463 59.8228 46.7608 59.8228 51.3356C59.8228 55.9104 56.1082 59.625 51.5399 59.6445V76.8358C54.7983 74.985 57.6983 72.5738 60.116 69.739C64.8667 64.1737 67.7472 56.9726 67.7472 49.1264C67.7537 31.5898 53.4102 17.2463 35.8801 17.2463Z",
    fill: "#494789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.202 20.1691C137.497 19.981 132.591 19.3262 128.275 17.5628C123.342 15.5529 120.257 12.791 120.257 12.791L120.335 19.7671C120.335 19.7671 117.263 19.3457 114.871 18.1527C112.422 16.9274 110.075 14.6193 110.075 14.6193V24.2795C110.075 24.2795 105.649 22.3799 102.641 19.0928C99.6342 15.8058 97.9426 12.1362 97.9426 12.1362C97.9426 12.1362 93.9242 16.6292 89.5235 19.6439C85.0385 22.717 80.3915 23.8386 78.7388 24.1628C78.0972 26.6718 77.7537 29.2976 77.7537 31.9946H77.7666C77.7666 49.5255 92.1095 63.8731 109.635 63.8731C127.16 63.8731 141.503 49.5255 141.503 31.9946C141.503 27.8194 140.68 23.8256 139.202 20.1626V20.1691Z",
    fill: "#383566"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.754 54.1278C102.031 54.1278 95.7537 47.8421 95.7537 40.1232H99.0806C99.0806 46.008 103.871 50.7997 109.754 50.7997C115.637 50.7997 120.427 46.008 120.427 40.1232H123.754C123.754 47.8482 117.47 54.1278 109.754 54.1278Z",
    fill: "#9F9ED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9557 12.1368C97.9557 12.1368 99.6473 15.8063 102.655 19.0934C105.662 22.3804 110.089 24.28 110.089 24.28V14.6199C110.089 14.6199 112.435 16.9279 114.885 18.1533C117.27 19.3462 120.348 19.7676 120.348 19.7676L120.27 12.7916C120.27 12.7916 123.355 15.5535 128.288 17.5633C132.598 19.3203 137.504 19.9816 139.215 20.1696C134.49 8.45423 122.999 0.123169 109.648 0.123169C94.8059 0.123169 82.2648 10.3863 78.752 24.1633C80.3982 23.8456 85.0517 22.724 89.5367 19.6444C93.9374 16.6232 97.9557 12.1368 97.9557 12.1368Z",
    fill: "#494789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.503 49.1232C151.503 31.5181 165.774 17.2463 183.38 17.2463C200.985 17.2463 215.256 31.5181 215.256 49.1232C215.256 66.7283 200.985 81 183.38 81C165.774 81 151.503 66.7283 151.503 49.1232Z",
    fill: "#383566"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M192.502 70.6376C200.221 70.6376 206.502 64.6295 206.502 57.2463H203.178C203.178 62.875 198.387 67.4581 192.502 67.4581C186.618 67.4581 181.827 62.875 181.827 57.2463H178.502C178.502 64.6295 184.784 70.6376 192.502 70.6376Z",
    fill: "#9F9ED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.192 36.7861L181.666 29.1037C181.705 34.2836 181.802 39.5413 181.802 39.5413L159.223 28.3711C165.083 21.577 173.738 17.2463 183.364 17.2463C195.973 17.2463 206.935 24.6694 212.095 35.3663L197.069 27.9368C197.107 32.436 197.192 36.7861 197.192 36.7861Z",
    fill: "#494789"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4270_198475",
    x: 0,
    y: 0,
    width: 219.256,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.0784314 0 0 0 0 0.294118 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4270_198475"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4270_198475",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoozBoys);
export default __webpack_public_path__ + "static/media/joozBoys.917e38c22bee9a4d99253b2d5956c64f.svg";
export { ForwardRef as ReactComponent };